import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { Prose } from "@/components/Prose";
import { LEGAL } from "@/lib/legal";
import { COMPANY } from "@/lib/api";

export default function Legal({ page }) {
  const doc = LEGAL[page];
  return (
    <div data-testid={`legal-page-${page}`}>
      <Seo title={doc.title} description={`${doc.title} for Explore HOA's, a property of ${COMPANY}.`} path={`/${page}`} />
      <PageHeader eyebrow={COMPANY} title={doc.title} subtitle={`Last Updated: ${doc.updated}`} />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <Prose text={doc.sections.map(([h, b]) => `## ${h}\n\n${b}`).join("\n\n")} />
        {page === "accessibility" && (
          <Link to="/contact?subject=Accessibility%20assistance" className="mt-6 inline-flex rounded-full bg-[#0B2150] text-white px-6 py-3 font-semibold hover:bg-[#03A896]" data-testid="accessibility-contact-link">Contact us for accessibility help</Link>
        )}
      </div>
    </div>
  );
}
